import React from 'react';

import { JE_TABLE_CLASSES } from '@/components/Tables/grid/StyledComponents';
import IconButton from '@mui/material/IconButton';
import cx from 'classnames';

import ClearIcon from '@mui/icons-material/Clear';

export function renderColgroup(props) {
  return (
    <colgroup>
      {props.map((c) => (
        <col
          id={c.id}
          key={c.id}
          className={cx(JE_TABLE_CLASSES.COLGROUP_COL, c.className)}
          span={c.span}
          style={c.style || {}}
        />
      ))}
    </colgroup>
  );
}

export function removeButton({ removeHandler }) {
  return (row) => (
    <IconButton
      size="small"
      color="error"
      className={cx(JE_TABLE_CLASSES.CELL_REMOVE)}
      onClick={() => (typeof removeHandler === 'function' ? removeHandler(row) : null)}
    >
      <ClearIcon sx={{ fontSize: 18 }} />
    </IconButton>
  );
}
